

































































import Vue from 'vue'
import VueHead from 'vue-head'

Vue.use(VueHead)

export default Vue.extend({
  name: 'HowTo',

  head: {
    title: {
      inner: '楽しみ方',
      separator: '｜',
      complement: 'ミュージックメーカー｜おだきゅうキッズ｜小田急電鉄',
    },
  },
})
